import React, { useEffect, useState } from 'react'
import TitleBar from '../../Common/TitleBar';
import SidePanelTaskCreator from '../../Common/SidePanelTaskCreator';
import DashboardHeader from '../../Common/DashboardHeader';
import { ScrollPanel } from 'primereact/scrollpanel';
import DashboardFooter from '../../Common/DashboardFooter';
import { IoWalletOutline } from "react-icons/io5";
import WalletTable from './WalletTable';
import { useDispatch } from 'react-redux';
import { creatorFetchData } from '../../../Redux/Actions/CreatorBuyPackageAction';
import { useNavigate } from 'react-router-dom';
import { FaSpinner } from 'react-icons/fa6';

const CreatorWallet = () => {
    const [isActive, setIsActive] = useState(true);
    const navigation = useNavigate()
    const toggleClass = () => {
        setIsActive(!isActive);
    };
    const dispatch = useDispatch()
    const [data, setData] = useState({})
    const [loader, setLoader] = useState({
        fetch: true
    })


    const fetchData = () => {
        setLoader({
            ...loader,
            fetch: true
        })
        dispatch(creatorFetchData("creator-wallet-balance", setData, setLoader, loader))
    }
    useEffect(() => {
        fetchData()
    }, [])

    return (
        <>
            <TitleBar title="Wallet" />
            <div className="dashboard earnings_payouts container-fluid overflow-hidden">
                <div className="row">
                    <div className={`col-lg-2 col-md-3 col-sm-4 col-12 side-nav ${isActive ? "nav-show" : "nav-hide"}`}>
                        <SidePanelTaskCreator />
                    </div>
                    <div className={` p-0 ${isActive ? "col-lg-10 col-md-9 col-sm-8 col-12" : "col-12"} main-content`}>
                        <div>
                            <div className="row">
                                <div className="col-xxl-12 col-xl-12 col-lg-12 ps-0 pe-0">
                                    <div className="dashboard-in main_task_wrapper">
                                        <DashboardHeader toggleSidebar={toggleClass} title="Wallet" />
                                        <ScrollPanel className="custombar2 content-area pt-0" style={{ height: "100vh" }}>
                                            <div className="content-area-in tab-style">
                                                <div className="account-block mx-2 mt-2">
                                                    <h6>Total Credits</h6>
                                                    <div className='d-flex align-items-center justify-content-center'></div>
                                                    {loader.fetch ? <div className='d-flex align-items-center justify-content-center'><FaSpinner className='spin' style={{ fontSize: "20px" }} /></div> :
                                                        <div className="d-flex task_main_wrap" style={{ borderBottom: "1px solid #1C1C1C1A", paddingBottom: "20px" }}>
                                                            <div className="task_process">
                                                                <span>Net Credit Balance</span>
                                                                <div className="progress_wrap" style={{ position: "relative" }}>
                                                                    <h3 style={{ fontWeight: "700" }}>{data.totalcredit}</h3>
                                                                </div>
                                                            </div>
                                                            <div className="task_process ps-3 pe-3">
                                                                <span className="text-center w-100">Invested</span>
                                                                <div className="task_process_bar text-center">
                                                                    <h3>{data.totaldebit}</h3>
                                                                </div>
                                                            </div>
                                                            <div className="task_process ps-3 pe-3">
                                                                <span className="text-center w-100">Remaining</span>
                                                                <div className="task_process_bar text-center">
                                                                    <h3>{data.balance}</h3>
                                                                </div>
                                                            </div>
                                                        </div>}
                                                    <div className="withdraw_request_wrap border-0" style={{ background: "#E5ECF680", borderRadius: "8px", padding: "16px" }}>
                                                        <div className="withdraw_wrap d-flex">
                                                            <div className="withdraw_para">
                                                                <h6 style={{ fontWeight: "400", marginBottom: "5px" }}>Withdraw Your Money to a Bank Account</h6>
                                                                <p>Withdraw money securely to your bank account. The minimum payout is Rs.100, and payments are released every Monday.</p>
                                                            </div>
                                                        </div>
                                                        <div className="withdraw_btn mt-lg-0 mt-md-4 mt-4">
                                                            <button className='theme-btn' type="button" onClick={() => navigation("/buy-package")}>Buy Now</button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <WalletTable />
                                            </div>
                                        </ScrollPanel>
                                    </div>
                                </div>
                                <div>
                                    <DashboardFooter />
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

        </>
    )
}

export default CreatorWallet
